import { render, staticRenderFns } from "./OrderReviewItems.vue?vue&type=template&id=a1d326a0&scoped=true"
import script from "./OrderReviewItems.vue?vue&type=script&lang=js"
export * from "./OrderReviewItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d326a0",
  null
  
)

export default component.exports